import { createFileRoute, Outlet } from "@tanstack/react-router";

// Pathless layout for /o/$slug/calendar/* — gives the week list (calendar/)
// + any future detail/timeline routes a common parent.
export const Route = createFileRoute("/o/$slug/calendar")({
  component: () => <Outlet />,
});
